var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
// we perform quite a few array.find, map.get checks here where we know for sure we'll get something back
/* eslint-disable @typescript-eslint/no-non-null-assertion */

// to trigger a re-render on a Map, we need to assign it to itself
/* eslint-disable no-self-assign */

import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { START_TIME_DEFAULT_VALUE, END_TIME_DEFAULT_VALUE } from '@square/dashboard-items-data/models/connect/availability-period/data';
import { areAvailabilityPeriodsIdentical, areAvailabilityPeriodsOverlapping, availabilityPeriodComparator, getLocalizedDaysOfWeek, WrappedAvailabilityPeriod } from '@dashboard/shared-ui/utils/availability/availability-period-utils';
export let AvailabilityModeEnum = /*#__PURE__*/function (AvailabilityModeEnum) {
  AvailabilityModeEnum["ALL_HOURS"] = "ALL_HOURS";
  AvailabilityModeEnum["CERTAIN_HOURS"] = "CERTAIN_HOURS";
  return AvailabilityModeEnum;
}({});
let AvailabilityPeriodsManager = (_class = class AvailabilityPeriodsManager extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "availabilityModeEnum", AvailabilityModeEnum);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
    _defineProperty(this, "initialSortedAvailabilityPeriods", []);
    _initializerDefineProperty(this, "wrappedAvailabilityPeriodsByDay", _descriptor3, this);
    _initializerDefineProperty(this, "initialAvailabilityMode", _descriptor4, this);
    _initializerDefineProperty(this, "availabilityMode", _descriptor5, this);
    _defineProperty(this, "createRawAvailabilityPeriod", (dayOfWeek, startLocalTime, endLocalTime) => {
      const availabilityPeriodData = this.store.createFragment('connect/availability-period/data', {
        dayOfWeek,
        startLocalTime: startLocalTime ?? START_TIME_DEFAULT_VALUE,
        endLocalTime: endLocalTime ?? END_TIME_DEFAULT_VALUE
      });
      const availabilityPeriod = this.store.createRecord('connect/availability-period', {
        availabilityPeriodData
      });
      return availabilityPeriod;
    });
    _defineProperty(this, "createAvailabilityPeriod", (dayOfWeek, startLocalTime, endLocalTime) => {
      return new WrappedAvailabilityPeriod({
        availabilityPeriodModel: this.createRawAvailabilityPeriod(dayOfWeek, startLocalTime, endLocalTime),
        daysOfWeek: this.daysOfWeek
      });
    });
    _defineProperty(this, "groupAvailabilityPeriods", availabilityPeriods => {
      const groupedAvailabilityPeriods = new Map();
      for (const day of this.daysOfWeek) {
        groupedAvailabilityPeriods.set(day, []);
      }
      for (const availabilityPeriod of availabilityPeriods) {
        const dayOfWeek = availabilityPeriod.availabilityPeriodModel.dayOfWeek;
        const availabilityPeriodsForDay = groupedAvailabilityPeriods.get(dayOfWeek);
        availabilityPeriodsForDay?.push(availabilityPeriod);
      }
      return groupedAvailabilityPeriods;
    });
    _defineProperty(this, "createDefaultRawAvailabilityPeriodForDays", (startLocalTime, endLocalTime) => {
      // TODO potentially pull this info from business hour endpoints
      return this.daysOfWeek.map(dayOfWeek => this.createRawAvailabilityPeriod(dayOfWeek, startLocalTime, endLocalTime));
    });
    // this is called when a seller toggles to CERTAIN_HOURS for the first time.
    _defineProperty(this, "createDefaultAvailabilityPeriodForDays", () => {
      // TODO potentially pull this info from business hour endpoints
      return this.daysOfWeek.map(dayOfWeek => this.createAvailabilityPeriod(dayOfWeek));
    });
    /**
     * Validates all wrapped availability periods and sets the
     * isStartValid and isEndValid keys of wrapped availability periods to true if any availability
     * period is overlapping with another availability period
     */
    _defineProperty(this, "validateWrappedAvailabilityPeriods", wrappedAvailabilityPeriods => {
      this.clearAllValidationErrors(wrappedAvailabilityPeriods);
      if (wrappedAvailabilityPeriods.length <= 1) {
        return;
      }
      const sortedWrappedAvailabilityPeriods = [...wrappedAvailabilityPeriods].sort((wrappedAvailabilityPeriodA, wrappedAvailabilityPeriodB) => {
        return availabilityPeriodComparator(wrappedAvailabilityPeriodA.availabilityPeriodModel, wrappedAvailabilityPeriodB.availabilityPeriodModel, this.daysOfWeek);
      });
      for (let i = 0; i < sortedWrappedAvailabilityPeriods.length - 1; i++) {
        const wrappedAvailabilityPeriodA = sortedWrappedAvailabilityPeriods[i];
        const wrappedAvailabilityPeriodB = sortedWrappedAvailabilityPeriods[i + 1];
        if (areAvailabilityPeriodsIdentical(wrappedAvailabilityPeriodA, wrappedAvailabilityPeriodB)) {
          wrappedAvailabilityPeriodA.isStartValid = false;
          wrappedAvailabilityPeriodA.isEndValid = false;
          wrappedAvailabilityPeriodB.isStartValid = false;
          wrappedAvailabilityPeriodB.isEndValid = false;
        } else if (areAvailabilityPeriodsOverlapping(wrappedAvailabilityPeriodA, wrappedAvailabilityPeriodB)) {
          wrappedAvailabilityPeriodA.isEndValid = false;
          wrappedAvailabilityPeriodB.isStartValid = false;
        }
      }

      // perform a wrap around validation (ie. is the last availability period overlapping with the first one)
      const lastAvailabilityPeriod = sortedWrappedAvailabilityPeriods[sortedWrappedAvailabilityPeriods.length - 1];
      const firstAvailabilityPeriod = sortedWrappedAvailabilityPeriods[0];
      if (lastAvailabilityPeriod.isLastDayOfWeek && firstAvailabilityPeriod.isFirstDayOfWeek && areAvailabilityPeriodsOverlapping(lastAvailabilityPeriod, firstAvailabilityPeriod)) {
        lastAvailabilityPeriod.isEndValid = false;
        firstAvailabilityPeriod.isStartValid = false;
      }
    });
    _defineProperty(this, "clearAllValidationErrors", wrappedAvailabilityPeriods => {
      for (const wrappedAvailabilityPeriod of wrappedAvailabilityPeriods) {
        wrappedAvailabilityPeriod.clearErrors();
      }
    });
  }
  initialize(availabilityPeriods) {
    const sortedAvailabilityPeriods = [...availabilityPeriods.sort((a, b) => {
      return availabilityPeriodComparator(a, b, this.daysOfWeek);
    })];

    // we are using getProperties to create a copy of the original availability periods. This will ensure that
    // when availability periods are modified, the initialSortedAvailabilityPeriods are not modified
    this.initialSortedAvailabilityPeriods = sortedAvailabilityPeriods.map(ap => ap.getProperties('dayOfWeek', 'startLocalTime', 'endLocalTime'));
    const wrappedAvailabilityPeriods = sortedAvailabilityPeriods.map(availabilityPeriod => new WrappedAvailabilityPeriod({
      availabilityPeriodModel: availabilityPeriod,
      daysOfWeek: this.daysOfWeek
    }));
    const wrappedAvailabilityPeriodsByDay = this.groupAvailabilityPeriods(wrappedAvailabilityPeriods);
    this.wrappedAvailabilityPeriodsByDay = wrappedAvailabilityPeriodsByDay;
    if (availabilityPeriods.length > 0) {
      this.availabilityMode = AvailabilityModeEnum.CERTAIN_HOURS;
      this.initialAvailabilityMode = AvailabilityModeEnum.CERTAIN_HOURS;
    } else {
      this.availabilityMode = AvailabilityModeEnum.ALL_HOURS;
      this.initialAvailabilityMode = AvailabilityModeEnum.ALL_HOURS;
    }
    this.validateWrappedAvailabilityPeriods(this.wrappedAvailabilityPeriods);
  }
  updateAvailabilityMode(newAvailabilityMode) {
    this.availabilityMode = newAvailabilityMode;
    if (this.availabilityMode === AvailabilityModeEnum.CERTAIN_HOURS && this.wrappedAvailabilityPeriods.length === 0) {
      const availabilityPeriods = this.createDefaultAvailabilityPeriodForDays();
      this.wrappedAvailabilityPeriodsByDay = this.groupAvailabilityPeriods(availabilityPeriods);
    }
  }
  addDefaultAvailabilityPeriod(dayOfWeek, startLocalTime, endLocalTime) {
    const newAvailabilityPeriod = this.createAvailabilityPeriod(dayOfWeek, startLocalTime, endLocalTime);
    const availabilityPeriodsForDay = this.wrappedAvailabilityPeriodsByDay.get(dayOfWeek);
    const newAvailabilityPeriodsForDay = [...availabilityPeriodsForDay, newAvailabilityPeriod];
    this.wrappedAvailabilityPeriodsByDay.set(dayOfWeek, newAvailabilityPeriodsForDay);
    this.wrappedAvailabilityPeriodsByDay = this.wrappedAvailabilityPeriodsByDay;
    this.validateWrappedAvailabilityPeriods(this.wrappedAvailabilityPeriods);
  }
  addAvailabilityPeriod(indexToAddTo, availabilityPeriod) {
    const dayOfWeek = availabilityPeriod.availabilityPeriodModel.dayOfWeek;
    const availabilityPeriodsForDay = this.wrappedAvailabilityPeriodsByDay.get(dayOfWeek);
    const newAvailabilityPeriodsForDay = [...availabilityPeriodsForDay.slice(0, indexToAddTo), availabilityPeriod, ...availabilityPeriodsForDay.slice(indexToAddTo)];
    this.wrappedAvailabilityPeriodsByDay.set(dayOfWeek, newAvailabilityPeriodsForDay);
    this.wrappedAvailabilityPeriodsByDay = this.wrappedAvailabilityPeriodsByDay;
    this.validateWrappedAvailabilityPeriods(this.wrappedAvailabilityPeriods);
  }
  deleteAvailabilityPeriod(id, dayOfWeek) {
    const availabilityPeriodsForDay = this.wrappedAvailabilityPeriodsByDay.get(dayOfWeek);
    const newAvailabilityPeriodsForDay = availabilityPeriodsForDay.filter(availabilityPeriod => availabilityPeriod.availabilityPeriodModel.idOrTempId() !== id);
    this.wrappedAvailabilityPeriodsByDay.set(dayOfWeek, newAvailabilityPeriodsForDay);
    this.wrappedAvailabilityPeriodsByDay = this.wrappedAvailabilityPeriodsByDay;
    this.validateWrappedAvailabilityPeriods(this.wrappedAvailabilityPeriods);
  }
  deleteAvailabilityPeriodsForDay(dayOfWeek) {
    this.wrappedAvailabilityPeriodsByDay.set(dayOfWeek, []);
    this.wrappedAvailabilityPeriodsByDay = this.wrappedAvailabilityPeriodsByDay;
    this.validateWrappedAvailabilityPeriods(this.wrappedAvailabilityPeriods);
  }
  handleAvailabilityPeriodChange({
    id,
    startLocalTime,
    endLocalTime,
    dayOfWeek
  }) {
    const availabilityPeriodsForDay = this.wrappedAvailabilityPeriodsByDay.get(dayOfWeek);
    const availabilityPeriod = availabilityPeriodsForDay.find(ap => ap.availabilityPeriodModel.idOrTempId() === id);
    availabilityPeriod.availabilityPeriodModel.startLocalTime = startLocalTime;
    availabilityPeriod.availabilityPeriodModel.endLocalTime = endLocalTime;
    this.wrappedAvailabilityPeriodsByDay.set(dayOfWeek, availabilityPeriodsForDay);
    this.wrappedAvailabilityPeriodsByDay = this.wrappedAvailabilityPeriodsByDay;
    this.validateAvailabilityPeriod(availabilityPeriod);
    if (!availabilityPeriod.isValid) {
      return;
    }
    this.validateWrappedAvailabilityPeriods(this.wrappedAvailabilityPeriods);
  }
  get daysOfWeek() {
    return getLocalizedDaysOfWeek(this.intl.primaryLocale);
  }
  get isModeCertainHours() {
    return this.availabilityMode === this.availabilityModeEnum.CERTAIN_HOURS;
  }
  get wrappedAvailabilityPeriods() {
    const availabilityPeriods = [];
    for (const wrappedAvailabilityPeriodsForDay of this.wrappedAvailabilityPeriodsByDay.values()) {
      availabilityPeriods.push(...wrappedAvailabilityPeriodsForDay);
    }
    return availabilityPeriods;
  }
  get hasValidationErrors() {
    return this.wrappedAvailabilityPeriods.some(ap => !ap.isValid);
  }
  get currentAvailabilityPeriods() {
    return this.wrappedAvailabilityPeriods.map(wap => wap.availabilityPeriodModel);
  }
  get isAvailabilityModeDirty() {
    return this.initialAvailabilityMode !== this.availabilityMode;
  }
  get isAvailabilityPeriodsDirty() {
    if (this.initialSortedAvailabilityPeriods.length !== this.currentAvailabilityPeriods.length) {
      return true;
    }
    const currentSortedAvailabilityPeriods = [...this.currentAvailabilityPeriods.sort((a, b) => {
      return availabilityPeriodComparator(a, b, this.daysOfWeek);
    })];
    for (let i = 0; i < this.initialSortedAvailabilityPeriods.length; i++) {
      const initialAp = this.initialSortedAvailabilityPeriods[i];
      const currentAp = currentSortedAvailabilityPeriods[i];
      if (!areAvailabilityPeriodsIdentical(initialAp, currentAp)) {
        return true;
      }
    }
    return false;
  }
  /**
   * Validates a single wrapped availability period. An availability period is invalid
   * if its start time is equal to its end time
   */
  validateAvailabilityPeriod(wrappedAvailabilityPeriod) {
    // clear validation errors
    // eslint-disable-next-line no-param-reassign
    wrappedAvailabilityPeriod.isStartValid = true;
    // eslint-disable-next-line no-param-reassign
    wrappedAvailabilityPeriod.isEndValid = true;
    const {
      startLocalTime,
      endLocalTime
    } = wrappedAvailabilityPeriod.availabilityPeriodModel;
    if (startLocalTime === endLocalTime) {
      wrappedAvailabilityPeriod.clearErrors();
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "wrappedAvailabilityPeriodsByDay", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Map();
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "initialAvailabilityMode", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return AvailabilityModeEnum.ALL_HOURS;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "availabilityMode", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return AvailabilityModeEnum.ALL_HOURS;
  }
}), _applyDecoratedDescriptor(_class.prototype, "initialize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateAvailabilityMode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateAvailabilityMode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addDefaultAvailabilityPeriod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addDefaultAvailabilityPeriod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addAvailabilityPeriod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addAvailabilityPeriod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteAvailabilityPeriod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteAvailabilityPeriod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteAvailabilityPeriodsForDay", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteAvailabilityPeriodsForDay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleAvailabilityPeriodChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleAvailabilityPeriodChange"), _class.prototype)), _class);
export { AvailabilityPeriodsManager as default };
/* eslint-enable no-self-assign */
/* eslint-enable @typescript-eslint/no-non-null-assertion */